<template>
    <div class="row">
        <div class="col-6">
            <div class="row mb-3">
                <div class="col">
                    <a class="btn btn-primary" :href="route('backoffice.events.export', {'id': this.eventId})">Esporta</a>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <statistic-counter
                        :counter="event.statistics.registered_users"
                        background="bg-warning"
                        title="Utenti Registrati"
                        icon="fa fa-user-plus"
                    ></statistic-counter>
                </div>
                <div class="col-6">
                    <statistic-counter
                        :counter="event.statistics.online_users"
                        background="bg-success"
                        title="Utenti Online"
                        icon="fa fa-users"
                    ></statistic-counter>
                </div>
            </div>
        </div>
        <div class="col-6">
            <admin-chat :default-author-name="defaultAuthorName" can-send :event-id="eventId"
                        :base-url="baseUrl"></admin-chat>
        </div>
    </div>
</template>

<script>
import StatisticCounter from './EventDashboardComponents/StatisticCounter';
import AdminChat from './AdminChat';
import gql from "graphql-tag";

export default {
    name: "EventDashboard",
    components: {
        StatisticCounter,
        AdminChat,
    },
    data() {
        return {
            event: {
                statistics: {
                    registered_users: 0,
                    online_users: 0
                }
            }
        }
    },
    props: {
        eventId: Number,
        baseUrl: String,
        defaultAuthorName: String,
    },
    apollo: {
        event: {
            query: gql`query GetEventStatistics($id: ID!) {
                event(id: $id) {
                    statistics {
                        registered_users
                        online_users
                    }
                }
            }`,
            variables() {
                return {
                    id: this.eventId,
                }
            },
            pollInterval: 2000,
        },
    },
    methods: {
        route(name, options) {
            return route(name, options);
        }
    }
}
</script>

<style scoped>

</style>
